export const SET_CREATOR_PRODUCTLIST_OPEN = 'SET_CREATOR_PRODUCTLIST_OPEN';
export const SET_CREATOR_MOBILE_MODAL_CONTENT = 'SET_CREATOR_MOBILE_MODAL_CONTENT';
export const SET_CREATOR_MOBILE_PRODUCTLIST_OPEN = 'SET_CREATOR_MOBILE_PRODUCTLIST_OPEN';

export const setCreatorProductListOpenRef = (identifier, value) => ({
  type: SET_CREATOR_PRODUCTLIST_OPEN,
  identifier,
  value,
});
export const setCreatorMobileModalContent = (value) => ({
  type: SET_CREATOR_MOBILE_MODAL_CONTENT,
  value,
});
export const setCreatorMobileProductListOpen = (value) => ({
  type: SET_CREATOR_MOBILE_PRODUCTLIST_OPEN,
  value,
});
